import React, { createContext, ReactChild, useEffect, useState } from "react";
// @ts-ignore
import VistaprintAuth from "@vp/auth";
import PageConfig from "../utils/PageConfig";

export interface IdentityContextType {
  isIdentityInitialized: boolean;
  identity?: any;
  auth?: any;
}

export const IdentityContext = createContext<IdentityContextType>({
  isIdentityInitialized: false,
});

export interface IdentityProviderProps {
  locale: string;
  children?: ReactChild | ReactChild[] | undefined | null;
}

export const IdentityProvider = (props: IdentityProviderProps) => {
  const { locale } = props;

  const [identityState, setIdentityState] = useState({
    auth: undefined,
    identity: undefined,
    isIdentityInitialized: false,
  });

  useEffect(() => {
    let mounted = true;
    const authConfig = {
      developmentMode: PageConfig.isDevelopment,
      culture: locale,
      options: {
        requireSession: true,
      },
    };

    if (mounted) {
      VistaprintAuth.init(authConfig, () => {
        const authLibrary = new VistaprintAuth.WebAuth();

        authLibrary.onUserIdentityUpdate((newIdentity: any) => {
          if (!newIdentity) {
            return;
          }

          setIdentityState({
            auth: authLibrary,
            identity: newIdentity,
            isIdentityInitialized: true,
          });
        });
      });
    }

    return () => {
      mounted = false;
    };
  }, [locale]);
  return (
    <IdentityContext.Provider value={{ ...identityState }}>
      {props.children}
    </IdentityContext.Provider>
  );
};
